<template>
  <div class="page-wrapper">
    <div class="title-content">
      <bread-crumb>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>风险检测</el-breadcrumb-item>
          <el-breadcrumb-item>开始检测</el-breadcrumb-item>
        </el-breadcrumb>
      </bread-crumb>
      <main-header>
        <template slot="title">开始检测</template>
      </main-header>
    </div>
    <project-set
      :projectData="projectData"
      :projectId="projectId"
      @selectPro="selectPro"
      :city="city"
      :uuid="uuid"
      @getNewList="getNewList"
    ></project-set>
    <div class="section-box">
      <div>
        <div class="title title-box">报告信息</div>
        <div class="pickers">
          <div class="pickers-flex">
            <div class="item">
              <div class="label">检测类型：</div>
              <div>年度检测</div>
            </div>
          </div>
          <div class="item">
            <div class="label">检测版本：房地产版本</div>
            <!-- <div class="picker">
              <el-select v-model="versionRadio" placeholder="请选择">
                <el-option
                  v-for="item in getTaxFirmEditionListData"
                  :key="item.edition"
                  :label="item.name"
                  :value="item.edition"
                ></el-option>
              </el-select>
            </div> -->
          </div>
          <div class="item">
            <!-- <i class="el-icon-warning icon-zq"></i> -->
            <div class="label">征期选择：</div>
            <template v-if="tableType.value != ''">
              <div class="picker">
                <template>
                  <el-select v-model="yearPicker.value" placeholder="请选择年">
                    <el-option
                      v-for="item in yearPicker.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </div>
            </template>
          </div>
          <!-- <div class="item">
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
              :open-delay="300"
            >
              <div slot="content">
                一般：增值税税负率=应纳税额÷适用税率销售收入<br />出口企业：增值税税负率=（当期销项-当期进项+进项转出+免抵退出口销售×适用税率+简易征收应纳税额）÷（适用税率销售+简易计税销售+免抵退出口销售）
                数据来源企业增值税申报表
              </div>
              <i class="el-icon-warning-outline icon-tip"></i>
            </el-tooltip>
            <div class="label">增值税税负率计算方法：</div>
            <div class="picker">
              <el-select v-model="taxRateCalculation" placeholder="请选择">
                <el-option
                  v-for="item in ratioTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div> -->
        </div>
      </div>
      <sa-footer>
        <div class="btn-primary new-next-btn ease" @click="projectNext">下一步</div>
      </sa-footer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import SectionTitle from "@/components/SectionTitle";
import QuanterPicker from "@/components/QuanterPicker";
import BreadCrumb from "@/components/BreadCrumb";
import Company from "./components/Company";
import projectSet from "./components/projectSet";
import MainHeader from "@/pages/components/MainHeader";
import ProgressDiagram from "@/pages/components/ProgressDiagram";
import Footer from "./components/Footer";
import { getHighestVersionPurchased } from "@/utils/helper";
import { editProjects, getRegion, getTaxFirmEditionList } from "@/api/api";

import { bSuperiorProjectListTest, addSubsetProjectId } from "@/api/fdc";

import Saalert from "@/plugins/saalert";
Vue.use(Saalert);

import {
  confirmUploadedTable,
  genTestReport,
  showModules,
  getVersion,
  useAuthorize,
  getProjectList,
  getProjectListNew,
  getAreaMsg,
  getCompanyMsgByTaxNo,
} from "@/api/api";
import { mapMutations, mapState } from "vuex";
import { zq2obj } from "@/utils/helper";

import { cloneDeep } from "lodash";

export default {
  components: {
    BreadCrumb,
    SectionTitle,
    QuanterPicker,
    Company,
    MainHeader,
    ProgressDiagram,
    SaFooter: Footer,
    projectSet,
  },
  props: {
    bankId: String,
    productID: [String, Number],
    productName: String,
    zqLocation: [String, Number],
    uuid: [String, Number],
  },
  computed: {
    ...mapState(["companyInfo", "authorization"]),
    city: function () {
      if (!this.areaTree) {
        return [];
      }
      const ret = cloneDeep(this.areaTree);
      function walk(data) {
        data.value = data.code;
        data.label = data.name;
        if (data.childNode && data.childNode.length > 0) {
          data.children = data.childNode;
          for (const child of data.children) {
            walk(child);
          }
        }
        delete data.childNode;
      }
      for (const areaTree of ret) {
        walk(areaTree);
      }
      return [...ret];
    },
  },
  data() {
    return {
      // 20221012新增参数
      ratioTypeList: [
        {
          label: "一般",
          value: 1,
        },
        {
          label: "出口企业",
          value: 2,
        },
      ],
      taxRateCalculation: "",
      getTaxFirmEditionListValue: "",
      getTaxFirmEditionListData: "",
      // 20221012新增参数
      thirdDataSource: "",
      // 选择已有项目：1 创建新项目：2
      selectvalueIndex: "1",
      // 默认选中项目
      selectvalue: "",
      areaTree: [],

      projectId: null,
      projectData: null,
      userNum: 0,
      zqs: [],
      versionRadio: 21,
      tableType: {
        options: [
          {
            value: 4,
            label: "年度报表",
          },
        ],
        value: null,
      },
      yearPicker: {
        options: [
          {
            value: "2022",
            label: "2022年",
          },
          {
            value: "2021",
            label: "2021年",
          },
          {
            value: "2020",
            label: "2020年",
          },
          {
            value: "2019",
            label: "2019年",
          },
          {
            value: "2018",
            label: "2018年",
          },
        ],
        value: null,
      },
      tableCards: [
        {
          total: 0,
          uploaded: 0,
          title: "",
          productID: this.productID,
          zq: null,
        },
        {
          total: 0,
          uploaded: 0,
          title: "",
          productID: this.productID,
          zq: null,
        },
      ],
    };
  },
  watch: {
    ["yearPicker.value"]: async function (val) {
      await this.onYearPickerChanged(val);
    },
  },
  mounted() {
    // this.getTaxFirm();
    localStorage.removeItem("taxSiteUsername");
    sessionStorage.removeItem("manualNsrsbh");
    sessionStorage.removeItem("isShowBase");

    // 手动自动
    sessionStorage.setItem("method", 1);

    this.getprojectList();
    this.getRegionData();

    //初始化显示为本年年度报表
    const current = new Date();
    this.tableType.value = 4;
    // 初始年份
    this.yearPicker.value = current.getFullYear().toString(); //2022
    localStorage.setItem("zqY", this.yearPicker.value);

    //清楚store中的选择税数据信息
    this.$store.commit("UploadTable/setSDSSelection", {
      SDSlist: null,
    });
  },
  methods: {
    getTaxFirm() {
      getTaxFirmEditionList().then((res) => {
        this.getTaxFirmEditionListData = res.data;
        if (res.data && res.data.length > 0) {
          this.versionRadio = res.data[0].edition;
        }
      });
    },
    projectNext() {
      if (!this.selectvalue) {
        this.$confirm(`请先选择项目！`, "温馨提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          showCancelButton: false,
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      if (!this.selectvalue.consumerEntity.industry) {
        this.$confirm("当前项目缺少行业信息，请前往客户清单补全。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({
              name: "custom",
            });
          })
          .catch(() => {});
        return;
      }
      // 判断是否是正确的税号
      // 判断是否对接税局

      if (!this.versionRadio) {
        this.$confirm(`请选择检测版本！`, "温馨提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确定",
          showCancelButton: false,
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      // if (!this.taxRateCalculation) {
      //   this.$confirm(`请选择增值税税负率计算方法！`, "温馨提示", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: "确定",
      //     showCancelButton: false,
      //   })
      //     .then(() => {})
      //     .catch(() => {});
      //   return;
      // }
      // 提示当前征期
      let typeName = this.zqs[0].slice(0, 4) + "年";
      this.$confirm("当前选中的征期为" + typeName, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "重新选择",
        type: "warning",
      })
        .then(() => {
          this.isRealTaxNo();
        })
        .catch(() => {});
    },
    isRealTaxNo() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getCompanyMsgByTaxNo(this.selectvalue.consumerEntity.nsrsbh, {}, 0).then((res) => {
        if (res.msgCode == 1) {
          getAreaMsg(this.selectvalue.consumerEntity.nsrsbh).then((res) => {
            this.loading.close();
            if (res.msgCode == 1) {
              this.available = res.data.available;
              this.thirdDataSource = res.data.thirdDataSource;
              this.changeID(this.selectvalue.id);
            }
          });
        } else {
          this.loading.close();
          this.$confirm("客户纳税人识别号有误，请重新创建客户?", "提示", {
            confirmButtonText: "创建客户",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$router.push({ name: "custom", query: { create: 1 } });
            })
            .catch(() => {});
        }
      });
    },
    getRegionData() {
      getRegion().then((res) => {
        this.areaTree = res.data;
      });
    },
    toUploadNextTo() {
      // 更新项目信息
      if (this.selectvalueIndex == 1) {
        let params = {
          id: this.selectvalue.id,
          uuid: this.uuid,
          nsrsbh: this.selectvalue.nsrsbh,
        };
        editProjects(params).then((res) => {
          if (res.msgCode == 1) {
            this.toNextAuto();
          } else {
            this.$message({
              message: res.msgInfo,
              type: "warning",
            });
          }
        });
        return;
        // 更新项目信息
      } else {
        this.toNextAuto();
      }
    },

    toNextAuto() {
      console.log(this.nsrsbhIndex)
      let dataPeriod = "";
      if (this.available) {
        dataPeriod = 3;
      } else {
        dataPeriod = 0;
      }
      this.$router.push({
        name: "upload-table-fdc",
        params: {
          id: this.tableCards[0].id,
          zq: this.tableCards[0].zq,
          zqLocation: this.zqs[0],
          dataPeriod: dataPeriod,
          selectvalueIndex: this.selectvalueIndex,
          version: this.versionRadio,
          user: this.userNum,
          nsrsbhIndex: this.nsrsbhIndex,
          // qykjzdIndex: this.qykjzdIndex,
        },
        query: {
          info: JSON.stringify(this.selectvalue),
          available: this.available ? 1 : 0,
          thirdDataSource: this.thirdDataSource,
          // taxRateCalculation: this.taxRateCalculation,
          taxfirmTag: this.getTaxFirmEditionListValue,
        },
      });
    },

    getNewList() {
      this.getprojectList();
    },

    selectPro(val) {
      this.selectvalue = val.info;
      this.selectvalueIndex = val.projectIndex;
      this.nsrsbhIndex = val.info.nsrsbh;
      sessionStorage.setItem("nsrsbh", this.nsrsbhIndex);
    },
    getprojectList() {
      bSuperiorProjectListTest().then((res) => {
        this.projectData = res.data;
        this.projectId = this.projectData.map((item) => {
          return item.id;
        });
      });
    },

    ...mapMutations("UploadTable", ["reset"]),

    async onYearPickerChanged(val) {
      const year = val;
      this.zqs = [];

      this.tableCards[0].zq = `${year}004`;
      this.zqs.push(`${year}004`);

      const secYear = year - 1;
      this.tableCards[1].zq = `${secYear}004`;
      this.zqs.push(`${secYear}004`);
      localStorage.setItem("zqY", this.yearPicker.value);
    },
    changeID(id) {
      addSubsetProjectId(id).then((res) => {
        this.selectvalue = res.data;
        this.nsrsbhIndex = res.data.nsrsbh;
        sessionStorage.setItem("nsrsbh", this.nsrsbhIndex);
        if (res.code == 200) {
          this.toUploadNextTo();
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.page-wrapper {
  padding-bottom: 84px;
}

#status_upload {
  padding: 0;

  >>> .el-dialog__footer {
    text-align: center;

    .redfont {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(241, 58, 76, 1);
      margin: 38px 0 19px 0;
    }

    .el-button {
      border: none;
      background: #007AFF;
      font-size: 22px;
      font-family: Microsoft YaHei;
      padding: 18px 50px;
      margin-bottom: 30px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }

  .headercss {
    >>> .el-tabs__header {
      .el-tabs__nav-wrap {
        .el-tabs__nav-scroll {
          .el-tabs__item {
            color: #7F9BC9;
            font-size: 18px;
          }

          .el-tabs__nav {
            left: 205px;

            .el-tabs__active-bar {
              height: 4px;
              background: #007AFF;
            }
          }

          .el-tabs__item.is-active {
            color: #062340;
            font-weight: bold;
          }
        }
      }
    }
  }

  >>> .el-dialog__body {
    padding: 0;
    overflow: hidden;
  }

  >>> .status_upload1 {
    .el-tabs__header .el-tabs__nav {
      left: 0px !important;
    }

    .el-tabs__item {
      height: 60px;
      font-size: 14px !important;
      line-height: 60px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-tabs__header.is-left {
      margin-right: 0;
      background: #eaedf7;
      font-size: 14px;
    }

    .el-tabs__item.is-left {
      text-align: left;
      padding: 0 20px;
      color: #7f9bc9;
    }

    .el-tabs__item.is-active {
      background: #fff;
      color: #007aff !important;
    }

    .el-tabs__active-bar {
      width: 0 !important;
    }

    .el-tabs__content {
    }

    .el-tabs__nav-wrap::after {
      content: none;
    }
  }
}

.table-container {
  max-height: 450px;
  overflow-y: auto;

  .table {
    width: 90%;
    margin: 0 auto;
    border-spacing: 0;

    tr {
      th {
        background: #EAEDF7;
        color: #7F9BC9;
        font-weight: normal;
        padding: 15px;
      }

      td {
        padding: 15px;
        border-left: 1px solid #EAEDF7;
      }

      td:last-child {
        border-right: 1px solid #EAEDF7;
      }
    }

    tr:nth-child(odd) {
      td {
        background: #F5F7FC;
      }
    }

    tr:last-child {
      td {
        border-bottom: 1px solid #F5F7FC;
      }
    }

    .statusup {
      text-align: center;
    }

    .statusup1 {
      color: #56D756;
      font-weight: bold;
    }
  }
}

.section-box {
  position: relative;
  padding-bottom: 10px;
  padding: 0;
}

.btn-test {
  font-size: 18px;
}

.content-body {
  margin: 20px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(17, 58, 99, 0.05);
  border-radius: 8px;
  min-height: 500px;
  padding: 30px 0 0;
}

.icon-zq {
  position: absolute;
  left: -24px;
  top: 11px;
  color: #D9D9D9;
  font-size: 16px;
}

.pickers {
  display: flex;
  flex-direction: column;
  margin-left: 68px;
  padding-bottom: 14px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);

  .item {
    margin: 12px 0;
    display: flex;
    align-items: center;
    position: relative;

    .icon-tip {
      position: absolute;
      top: -4px;
      left: -22px;
      cursor: pointer;
      padding: 4px;
    }
  }

  .label {
    display: inline-block;
    margin-right: 8px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }

  .labels:before {
    content: '*';
    color: red;
    position: relative;
    top: 2px;
    left: -2px;
  }

  .picker {
    // margin: 0 20px;
  }
}

.cards {
  margin-top: 20px;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  flex-wrap: wrap;

  .card {
    flex: auto 0 0%;
    width: 250px;
    margin: 30px auto;
    transition: 0.3s all;
  }

  .card:hover {
    transform: translateY(-5px);
  }

  .placeholder {
    width: 250px;
    height: 0px;
    margin: 0px auto;
  }
}

.progressdis {
  width: 90%;
  margin: 24px auto;
}

.picker >>> .el-input__inner {
  height: 36px;
  line-height: 36px;
  width: 325px;
}

>>> .el-input__icon {
  line-height: 36px;
}

.pickers .pickerDq {
  margin-left: -6px;
}

.pickers-flex {
  display: flex;
  align-items: center;
}

.pickers .pickers-flex-left {
  margin-right: 80px;
}

.title-box {
  padding: 24px 0 12px 24px;

  .fix-title-tips {
    font-size: 14px;
    color: #F5222D;
    margin-left: 16px;
  }
}

.title-content {
  // width: 1260px;
  height: 96px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -1px 0px 0px rgba(238, 238, 238, 1);
}

>>>.bread-crumb-wrapper {
  margin-top: 0;
}

>>>.bread-crumb-wrapper {
  padding: 0;
  line-height: 20px;
  padding: 16px 0 16px 30px;
}

.page-title-wrapper {
  padding: 0;
  padding-left: 30px;
  line-height: 28px;
}

.new-next-btn {
  width: 360px;
  height: 46px;
  line-height: 46px;
  background: #2F54EB;
  border-radius: 4px;
  box-sizing: border-box;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}

.new-next-btn:hover {
  background: #0f3bec;
  color: #fff;
}

.ease {
  transition: all 0.3s;
}
</style>
